// dependencies
import { useMutation, useQuery } from "@tanstack/react-query";

// queries
import { cohortQuery } from "../../queries";
import { archiveCohort, deleteCohortInternalAPI, getCohorts, reactivateCohort } from "../../services/defs/internal-api";
import { PYUseMutationOptions } from "../StandardQueryArguments";

// schema
/**
 * Returns a company's cohorts, by default only cohorts with 3 or more members are returned
 * @param showAll shows all cohorts including those with less than 3 members
 * @returns
 */
export const useCohorts = () => {
	return useQuery({
		queryKey: ["get-cohorts", "active"],
		queryFn: async () => {
			const response = await getCohorts("active");
			return response;
		},
		meta: {
			disableDefaultErrorHandling: true,
		},
	});
};

export const useCohort = (cohortID: string) => {
	return useQuery(cohortQuery(cohortID));
};

export const useArchivedCohorts = () => {
	return useQuery({
		queryKey: ["get-cohorts", "archived"],
		queryFn: async () => {
			const response = await getCohorts("archived");
			return response;
		},
		meta: {
			disableDefaultErrorHandling: true,
		},
	});
};

export const useArchiveCohort = (options: PYUseMutationOptions) => {
	return useMutation({
		mutationFn: async (variables: { cohortID: string }) => {
			return await archiveCohort(variables.cohortID);
		},
		...options,
	});
};

export const useReactivateCohort = (options: PYUseMutationOptions) => {
	return useMutation({
		mutationFn: async (variables: { cohortID: string }) => {
			return await reactivateCohort(variables.cohortID);
		},
		...options,
	});
};

export const useDeleteCohort = (options: PYUseMutationOptions) => {
	return useMutation({
		mutationFn: async (variables: { cohortID: string }) => {
			return await deleteCohortInternalAPI(variables.cohortID);
		},
		...options,
	});
};
